import { render, staticRenderFns } from "./RegistrationFreelancer.vue?vue&type=template&id=4e8ce7da&"
import script from "./RegistrationFreelancer.vue?vue&type=script&lang=js&"
export * from "./RegistrationFreelancer.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationFreelancer.vue?vue&type=style&index=0&id=4e8ce7da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports